import { Tooltip, Space, Button, Badge } from "antd";
// import { Image } from "antd";
// import { PrinterOutlined, QuestionCircleOutlined, DeleteOutlined } from "@ant-design/icons";
import { ExclamationCircleOutlined, PrinterOutlined, EditOutlined } from "@ant-design/icons";
import {
  EditableRow,
  EditableCell,
  RowDrag,
} from "../../../components/table/TableEditAble";
import { formatCommaNumber, formatMoney } from "../../../utils/util";
import { TagDocRuncode } from "../../../components/badge-and-tag/ERP";
import { TagItemTypes } from "../../../components/badge-and-tag/ERP";
import dayjs from "dayjs";
import { RiDeleteBin5Line } from "react-icons/ri";

import { docLinkRender } from "../../../components/table/DocLink";
export const DEFAULT_PARAMETER_ROWS = [
  { seq: 1, inspection: "pH", spec: "" },
  { seq: 2, inspection: "Brix", spec: "" },
  { seq: 3, inspection: "%Salt", spec: "" },
  { seq: 4, inspection: "%Acidity x6", spec: "" },
  { seq: 5, inspection: "Bostwick ร้อน 90C", spec: "" },
  { seq: 6, inspection: "เวลาปล่อย", spec: "" },
  { seq: 7, inspection: "เวลาปล่อยหมด", spec: "" },
];

export const componentsEditable = {
  body: { row: EditableRow, cell: EditableCell },
};

export const componentsDraggableEditable = {
  body: { row: RowDrag, cell: EditableCell },
};

export const accessColumn = ({ handleEdit, handleDelete, handleView, handlePrint }) => [
  {
    key: "id",
    dataIndex: "id",
    align: "left",
    hidden: true,
  },
  {
    title: "รหัสสินค้า",
    dataIndex: "fg_code",
    key: "fg_code",
    sorter: (a, b) => (a?.fg_code || "").localeCompare(b?.fg_code || ""),
    width: 200,
  },
  {
    title: "ชื่อสินค้า",
    dataIndex: "fg_name",
    key: "fg_name",
    // width: "25%",
    sorter: (a, b) => (a?.fg_name || "").localeCompare(b?.fg_name || ""),
    ellipsis: { showTitle: false },
    render: (v) => (
      <Tooltip placement="topLeft" title={v}>
        {v}
      </Tooltip>
    ),
  },
  {
    title: "Code",
    dataIndex: "code",
    key: "code",
    sorter: (a, b) => (a?.code || "").localeCompare(b?.code || ""),
    width: 200,
    /* กดเลขที่เอกสารเพื่อเปิดหน้าแสดงข้อมูล */
    render: docLinkRender(handleView, "เปิดดู Master Process"),
  },
  // {
  //   title: "ประเภทสินค้า",
  //   dataIndex: "product_type",
  //   key: "product_type",
  //   sorter: (a, b) =>
  //     (a?.product_type || "").localeCompare(b?.product_type || ""),
  //   width: 140,
  //   sortDirections: ["descend", "ascend"],
  //   render: (data) => <TagDocRuncode result={data} />,
  // },
  // {
  //   title: "จำนวนวัตถุดิบ",
  //   dataIndex: "bom_qty",
  //   key: "bom_qty",
  //   sorter: (a, b) =>
  //     (a?.bom_qty.toString() || "").localeCompare(b?.bom_qty || ""),
  //   width: 140,
  // },
  // {
  //   title: "จำนวน Step",
  //   dataIndex: "mp_qty",
  //   key: "mp_qty",
  //   sorter: (a, b) =>
  //     (a?.mp_qty.toString() || "").localeCompare(b?.mp_qty || ""),
  //   width: 140,
  // },
  {
    title: "อัพเดทล่าสุด",
    dataIndex: "updated_date",
    key: "updated_date",
    width: "10%",
    sorter: (a, b) =>
      (a?.updated_date || "").localeCompare(b?.updated_date || ""),
    render: (_, head) =>
      head?.updated_date ? dayjs(head.updated_date).format("DD/MM/YYYY") : "",
  },
  {
    title: "Action",
    key: "operation",
    width: "130px",
    fixed: "right",
    render: (text, record) => (
      <Space>
        <Badge size="small" offset={[0, 1]}>
          <Button
            icon={<ExclamationCircleOutlined />}
            className="bn-success-outline"
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={(e) => handleView(record)}
            size="small"
          />
        </Badge>
        <Badge size="small" offset={[0, 1]}>
          <Button
            icon={<EditOutlined />}
            className="bn-primary-outline"
            title="แก้ไข"
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={() => handleEdit(record)}
            size="small"
          />
        </Badge>
        <Badge size="small" offset={[0, 1]}>
          <Button
            icon={<PrinterOutlined />}
            className="bn-warning-outline"
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={(e) => handlePrint(record)}
            size="small"
          />
        </Badge>
      </Space>
    ),
  },
];

const PCT_GRAM_UNITS = ["g", "gm", "gram", "grams", "กรัม"];
export const ratioInKg = (r) => {
  const v = Number(r?.ratio || 0);
  const u = String(r?.unit || "").trim().toLowerCase();
  return PCT_GRAM_UNITS.includes(u) ? v / 1000 : v;
};
export const percentColumn = (total) => ({
  title: "%",
  key: "percent",
  align: "center",
  width: 110,
  render: (_, r) =>
    total > 0 ? ((ratioInKg(r) / total) * 100).toFixed(2) : "0.00",
});

/* น้ำหนักวัตถุดิบ = (น้ำหนักเข้าสูตร / multiply) / (yield / 100)
   multiply ว่างหรือ 0 ถือเป็น 1, yield ว่างหรือ 0 ถือเป็น 100% กันหารศูนย์ */
export const calcRawWeight = (r) => {
  const ratio = Number(r?.ratio || 0);
  const mul = Number(r?.multiply || 0) > 0 ? Number(r.multiply) : 1;
  const yld = Number(r?.yield || 0) > 0 ? Number(r.yield) : 100;
  return parseFloat((ratio / mul / (yld / 100)).toFixed(2));
};

/** get column for edit table parameter */
export const MaterialColumns = (step, { handleDeleteMaterial, totalRatio = 0 }) => [
  {
    key: "sort",
    width: 56,
    align: "center",
  },
  {
    title: "No.",
    dataIndex: "seq",
    key: "seq",
    width: 70,
  },
  {
    title: "รหัสวัตถุดิบ",
    dataIndex: "mat_code",
    key: "mat_code",
    width: 150,
  },
  {
    title: "ชื่อวัตถุดิบ",
    dataIndex: "mat_name",
    key: "mat_name",
  },
  {
    title: "น้ำหนักเข้าสูตร",
    key: "ratio",
    dataIndex: "ratio",
    editable: true,
    required: true,
    type: "input",
    align: "center",
    width: 120,
    className: "field-edit pe-2",
    // render: (v) => formatMoney(Number(v || 0)),
  },
  percentColumn(totalRatio),
  {
    title: "Multiply",
    key: "multiply",
    dataIndex: "multiply",
    editable: true,
    required: false,
    type: "input",
    align: "center",
    width: 120,
    className: "field-edit pe-2",
  },
  {
    title: "Yield (%)",
    key: "yield",
    dataIndex: "yield",
    editable: true,
    required: false,
    type: "input",
    align: "center",
    width: 120,
    className: "field-edit pe-2",
  },
  {
    title: "น้ำหนักวัตถุดิบ",
    key: "qty",
    dataIndex: "qty",
    // editable: true,
    // required: true,
    type: "input",
    align: "center",
    width: 150,
    render: (_, record) => calcRawWeight(record),
    // className: "field-edit pe-2",
  },
  {
      title: "ขั้นตอน",
      key: "method",
      dataIndex: "method",
      editable: true,
      required: false,
      type: "input",
      align: "center",
      width: 200,
      className: "field-edit pe-2",
    },
  {
    title: "ชนิดวัตถุดิบ",
    dataIndex: "typename",
    key: "typename",
    width: 140,
    sortDirections: ["descend", "ascend"],
    render: (data) => <TagItemTypes data={data} />,
  },
  {
    title: "หน่วย",
    dataIndex: "unit",
    key: "unit",
    width: 90,
  },
  {
    title: "ตัวเลือก",
    key: "operation",
    width: 90,
    fixed: "right",
    render: (_, record) => (
      <Button
        className="bt-icon"
        size="small"
        danger
        icon={
          <RiDeleteBin5Line style={{ fontSize: "1rem", marginTop: "3px" }} />
        }
        onClick={() => handleDeleteMaterial(step.key, record.id)}
      />
    ),
  },
];

export const buildMaterialColumns = (
  step,
  { handleDeleteMaterial, handleSave, handleModalSelect = () => {}, totalRatio = 0 } = {},
) => {
  const col = MaterialColumns(step, { handleDeleteMaterial, totalRatio });

  if (!handleSave) {
    return col;
  }

  return col.map((item) => {
    if (!item.editable) {
      return item;
    }

    return {
      ...item,
      onCell: (record) => ({
        record,
        editable: item.editable,
        dataIndex: item.dataIndex,
        title: item.title,
        handleSave,
        fieldType: !!item?.textArea,
        required: !!item?.required,
        type: item?.type || "input",
        autocompleteOption: item.autocompleteOption,
        modalSelect: handleModalSelect,
      }),
    };
  });
};

/** get column for edit table parameter */
export const pkColumns = ({ handleActionPK }) => {
  return [
    {
      title: "No.",
      key: "seq",
      dataIndex: "seq",
      align: "left",
      width: 80,
      // render: (_, record, idx) => <span key={record?.code}>{idx + 1}</span>,
    },
    {
      title: "รหัสบรรจุภัณฑ์",
      key: "pk_code",
      dataIndex: "pk_code",
    },
    {
      title: "ชื่อบรรจุภัณฑ์",
      key: "pk_name",
      dataIndex: "pk_name",
    },
    {
      title: "ชนิดบรรจุภัณฑ์",
      dataIndex: "packtype",
      key: "packtype",
      width: 140,
      sortDirections: ["descend", "ascend"],
      render: (data) => <TagItemTypes data={data} />,
    },
    {
      title: "จำนวน",
      key: "qty",
      dataIndex: "qty",
      editable: true,
      required: true,
      align: "right",
      width: 120,
      className: "field-edit pe-2",
      render: (v) => formatCommaNumber(Number(v || 0)),
    },
    {
      title: "ตัวเลือก",
      align: "center",
      key: "operation",
      dataIndex: "operation",
      render: (_, record, idx) => handleActionPK(record),
      width: "90px",
      fixed: "right",
    },
  ].filter((item) => !item.hidden);
};

export const columnsPKEditable = (
  handleSave,
  handleModalSelect,
  { handleActionPK, nameOption },
) => {
  const col = pkColumns({ handleActionPK, nameOption });
  return col.map((col, ind) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => {
        // console.log(record);
        return {
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          handleSave,
          fieldType: !!col?.textArea,
          required: !!col?.required,
          type: col?.type || "input",
          autocompleteOption: col.autocompleteOption,
          modalSelect: handleModalSelect,
        };
      },
    };
  });
};

export const parameterColumns = ({ handleAction }) => [
  {
    title: "ลำดับ",
    key: "seq",
    dataIndex: "seq",
    align: "center",
    width: 90,
  },
  {
    title: "การตรวจสอบ",
    key: "inspection",
    dataIndex: "inspection",
    align: "left",
    editable: true,
    required: true,
    type: "input",    
    className: "field-edit",
  },
  {
    title: "ค่า spec",
    key: "spec",
    dataIndex: "spec",
    editable: true,
    required: false,
    type: "input",
    width: 150,
    className: "field-edit",
  },
  {
    title: "target",
    key: "target",
    dataIndex: "target",
    editable: true,
    required: false,
    type: "input",
    className: "field-edit",
    width: 150,
  },
  {
    title: "ตัวเลือก",
    align: "center",
    key: "operation",
    dataIndex: "operation",
    render: (_, record) => handleAction(record),
    width: "90px",
    fixed: "right",
  },
];

export const columnsParameterEditable = (handleSave, { handleAction }) => {
  const col = parameterColumns({ handleAction });

  return col.map((item) => {
    if (!item.editable) {
      return item;
    }

    return {
      ...item,
      onCell: (record) => ({
        record,
        editable: item.editable,
        dataIndex: item.dataIndex,
        title: item.title,
        handleSave,
        fieldType: !!item?.textArea,
        required: !!item?.required,
        type: item?.type || "input",
      }),
    };
  });
};

export const PG = {
  id: null,
  product_code: null,
  product_name: null,
  pg_type: null,
  sample_ref: null,
  code: null,
  unit: null,
  weight_nw: 0,
  weight_gw: 0,
  feature: null,
  remarks: null,
  active_status: null,
};
